import { black, gray7, green, greenLight, spacer24, spacer64 } from '@spotify-internal/encore-foundation'; // Typography

export var fontWeightBook = 400;
export var fontWeightBold = 700;
export var fontWeightBlack = 900; // z-index master list

export var zIndexFixed = 1030;
export var zIndexDialogBackdrop = 1040;
export var zIndexDialog = 1050;
export var zIndexPopover = 1060; // Links

export var linkColor = black;
export var linkDecoration = 'underline';
export var linkHoverColor = greenLight;
export var linkHoverDecoration = 'underline';
export var linkActiveColor = green; // Shared Nav Styles

export var navBg = gray7; // Sidebar

export var sidebarBaseWidth = '200px';
export var sidebarSlimBaseWidth = spacer64;
export var sidebarPadding = spacer24; // Transitions + Animations

export var transitionFade = '0.1s'; // Misc

export var cursorDisabled = 'not-allowed'; // Disabled cursor for form controls and buttons.